export default __webpack_public_path__ + "media/src/assets/images/bg2-35d98ed09d532e11aeb39bb18bc5e9a4.png";